export default {
  header: {
    title: '💛 Napiwek dla zespołu',
    subtitle: '100% trafia do pracowników',
  },
  buttons: {
    other: 'Inny',
    none: 'Brak',
  },
  summary_label: 'Napiwek',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} to maksymalna kwota napiwku',
      },
    },
  },
};
